import Lenis from "lenis";
import { useEffect } from "react";

export function useSmoothScroll() {
  useEffect(() => {
    // Heavier, calmer glide — the page should feel like it has mass.
    const lenis = new Lenis({
      duration: 1.35,
      easing: (t: number) => 1 - Math.pow(2, -10 * t),
      smoothWheel: true,
      wheelMultiplier: 0.95,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);
}
